import { createSlice } from '@reduxjs/toolkit'
import { getTaxonomyDescriptions } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState = { 
    taxonomyDescriptions: [],
    loading: "idle",
    error: null 
}

const taxonomyDescriptionsSlice = createSlice({
    name: 'taxonomyDescriptions',
    initialState,
    reducers: {
        clearTaxonomyDescriptionsError: (state) => {
            state.error = null
            state.loading = "idle"
        }
    },
    extraReducers: {
        [getTaxonomyDescriptions.pending]: (state) => {
            state.loading = "loading"; 
            state.error = null
        },
        [getTaxonomyDescriptions.fulfilled]: (state, action) => {
            state.loading = "succeeded";
            state.taxonomyDescriptions = action.payload
        },
        [getTaxonomyDescriptions.rejected]: (state, action) => {
            state.loading = "failed"; 
            state.error = action.error.message
        },
        [logOut]: (state) => initialState
    }
})

export const {cleartaxonomyAdminError} = taxonomyDescriptionsSlice.actions;
export default taxonomyDescriptionsSlice.reducer